import { Component } from 'react';
import PropTypes from 'prop-types';
import TableRowComponent from './TableRowComponent';

class TableBodyComponent extends Component {

  render() {
    const { rowData, columnNames } = this.props;

    const rows = rowData.map((row, i) => (
      <TableRowComponent
        row={row}
        // eslint-disable-next-line react/no-array-index-key
        key={i}
        columnNames={columnNames}
      />
    ));

    return (
      <tbody>
        {rows}
      </tbody>
    );
  }
}

TableBodyComponent.propTypes = {
  rowData: PropTypes.arrayOf(PropTypes.shape({})),
  columnNames: PropTypes.arrayOf(PropTypes.string),
};

TableBodyComponent.defaultProps = {
  rowData: [],
  columnNames: [],
};

export default TableBodyComponent;
